"use client"

interface CodexArtPlaceholderProps {
  /** Omitted for locked entries, whose identity is the thing being withheld */
  name?: string
  dimmed?: boolean
}

/**
 * Stand-in tile for a codex entry with nothing to show.
 *
 * Two cases, and the difference matters:
 * - Discovered but no portrait art yet (Shadowblade, Shrine): show "?" *and* the
 *   name, because the grid has no captions and a bare "?" leaves the tile
 *   anonymous even though the player has earned it.
 * - Not yet discovered: show "?" alone. The name is exactly what discovery is
 *   meant to reveal, so printing it here would give the entry away.
 */
export const CodexArtPlaceholder = ({ name, dimmed = false }: CodexArtPlaceholderProps) => (
  <div
    className={`w-full h-full flex flex-col items-center justify-center gap-0.5 px-1 ${
      dimmed ? "grayscale opacity-40" : ""
    }`}
  >
    <span className="text-2xl font-bold leading-none text-amber-400">?</span>
    {name && (
      <span className="text-[10px] font-bold leading-tight text-center text-amber-200/80 break-words">
        {name}
      </span>
    )}
  </div>
)
